import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { resetDataUploadFile, uploadFileThunk } from "redux/Reducers/Concierge/uploadFileSlicer";
import { approveQuotationThunk, resetDataApproveSolicitation } from "redux/Reducers/Concierge/approveQuotationSlicer";
import { approveQuotationWithTermThunk, resetApproveSolicitationWithTermData } from "redux/Reducers/Concierge/approveQuotationWithTerm";

import "Assets/styles/default/components/Concierge/Modals/StepApprovalModal.less"

import { useForm } from "antd/es/form/Form";
import { Col, Form, Row, Upload, VertButton, VertCheckbox, VertInput, VertModal, VertTypography, notification } from "@vertem-core/vertice-ds";

const StepApprovalModal = (props) => {
  const { isOpen, setIsOpen, solicitationId, step, withTerm, onSuccess, stepBeforeRedemption, setResponse2FA } = props;

  const [ form ] = useForm();

  const dispatch = useDispatch();

  const [hasNote, setHasNote] = useState(false);
  const [termUrl, setTermUrl] = useState(null);

  const {
    dataApproveSolicitation,
    loadingApproveSolicitation,
    approveSolicitationHasError,
    errorsApproveSolicitation,
  } = useSelector(
    (state) => state.ApproveQuotationSolicitation
  );

  const {
    approvalWithTermData,
    isApprovalWithTermLoading,
    approvalWithTermHasError,
    errorsApprovalWithTerm
  } = useSelector(
    (state) => state.ApproveQuotationWithTerm
  );

  const {
    dataUploadFile,
    loadingUploadFile,
    errorUploadFile
  } = useSelector(
    (state) => state.UploadFile
  );

  const validators = {
    note: {
      rules: [
        {
          required: true,
          message: "Campo obrigatório.",
        }
      ]
    }
  }

  const onClose = () => {
    dispatch(resetDataUploadFile());
    setTermUrl(null);

    setIsOpen(false);
  }

  const handleTermChange = async ({ file, onSuccess, onError }) => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await dispatch(uploadFileThunk(formData)).unwrap();
      onSuccess(response, file);
    } catch (error) {
      onError(error);

      notification.error({
        message: "Houve um erro durante o envio do termo.",
      });
    }
  };

  const handleTermRemove = () => {
    setTermUrl(null);
  }

  const submitDisableConditions = () => {
    return withTerm && !termUrl;
  }

  const handleSubmit = () => {
    const fieldsToValidate = hasNote ? ["note"] : [];
    form.validateFields(fieldsToValidate)
      .then((values) => {
        if (!solicitationId) return;

        const { note } = values;

        const approval = {
          solicitationId,
          note: hasNote ? note : "n/i",
        };

        if (withTerm) {
          approval.fileUrl = termUrl;
          dispatch(approveQuotationWithTermThunk(approval));
          return;
        }
        dispatch(approveQuotationThunk(approval));
      })
      .catch((err) => {
        console.log(err);

        notification.error({
          message: "Preencha os campos corretamente.",
        });
      });
  }

  useEffect(() => {
    if (dataUploadFile) setTermUrl(dataUploadFile);
  }, [dataUploadFile]);

  useEffect(() => {
    if (!dataApproveSolicitation && !approvalWithTermData) return;

    notification.success({
      message: stepBeforeRedemption ? "Resgate foi aprovado." : "Solicitação foi aprovada."
    })

    const approvalData = withTerm ? approvalWithTermData : dataApproveSolicitation;

    setIsOpen(false);
    onSuccess(approvalData);
  }, [dataApproveSolicitation, approvalWithTermData]);

  useEffect(() => {
    if (!errorUploadFile) return;

    notification.error({
      message: "Houve um erro ao enviar termo, tente novamente.",
    });

    dispatch(resetDataUploadFile());
  }, [errorUploadFile]);

  useEffect(() => {
    if (!approveSolicitationHasError && !approvalWithTermHasError) return;

    const errorsApproval = withTerm ? errorsApprovalWithTerm : errorsApproveSolicitation;
    const errorCode = errorsApproval.responseData?.code;

    if (errorCode?.includes('326')) {
      notification.error({
        message: errorsApproval.responseData.message
      });
    }
    else if (errorCode?.includes('406')) {
      setResponse2FA(errorsApproval);
    }
    else {
      notification.error({
        message: "Houve um erro ao aprovar etapa, tente novamente."
      });
    }

    dispatch(resetDataApproveSolicitation());
    dispatch(resetApproveSolicitationWithTermData());

  }, [approveSolicitationHasError, approvalWithTermHasError]);

  return (
    <VertModal
      className="step-approval-modal"
      width={"50%"}
      open={isOpen}
      onCancel={onClose}
      title={`Etapa: ${step}`}
      destroyOnClose={true}
    >
      <Row>
        <Col>
          <VertTypography.Title className="color-title">
            {stepBeforeRedemption ? "Você aprova este resgate?" : "Você aprova esta solicitação?"}
          </VertTypography.Title>
        </Col>
      </Row>

      <Row className="note-container">
        <Col span={24}>
          <VertCheckbox
            className="note-checkbox"
            checked={hasNote}
            onChange={() => setHasNote(!hasNote)}
          >
            Adicionar comentário
          </VertCheckbox>
        </Col>

        {
          hasNote && (
            <Col span={24}>
              <Form form={form}>
                <Form.Item
                  name="note"
                  rules={validators.note.rules}
                >
                  <VertInput.TextArea
                    className="note"
                    placeholder="Adicione um comentário"
                  />
                </Form.Item>
              </Form>
            </Col>
          )
        }
      </Row>

      <Row className="actions" justify={"space-between"}>
        <Col>
          {
            withTerm && ( 
              <Upload 
                className="btn-term-upload" 
                customRequest={handleTermChange}
                onRemove={handleTermRemove}
              >
                <VertButton
                  className="button-concierge"
                  loading={loadingUploadFile}
                >
                  Anexar Termo
                </VertButton>
              </Upload>
            )
          }
        </Col>

        <Col className="action-btn-group">
            <VertButton
              className="button-concierge"
              onClick={onClose}
            >
              Não
            </VertButton>

            <VertButton
              className="btn-confirm"
              type="highlight"
              size="default"
              disabled={submitDisableConditions()}
              loading={loadingApproveSolicitation || isApprovalWithTermLoading}
              onClick={handleSubmit}
            >
              Sim
            </VertButton>
          </Col>
      </Row>
    </VertModal>
  )
}

export default StepApprovalModal;